import React from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import { Typography, Grid, Button } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import { drawerWidth } from "../constants";
import { useNavigate } from "react-router-dom";

const DetailsPageHeader = ({
  onBackClick,
  mainTitle,
  bgColor,
  buttonText,
  editEnabled,
  setEditEnabled,
  cancelButton,
  handleSave,
  onCancelClick,
  submitButtonText,
  loading,
  additionalButton,
  additionalButtonUrl,
  showSendLink,
  onSendLink,
  showGetLink,
  onGetLink,
  hideBackArrow = false,
  disableEdit = false,
  disableSendLink = false,
  disableGetLink = false,
  // Optional: custom right-side buttons. When provided, they replace the
  // default buttons and are laid out right-aligned with even spacing.
  actions,
  // handleGetIdQuickTales,
  // selected,
  // setSelected,
  // handleUpdateProData,
}) => {
  const navigate = useNavigate();

  const handleAdditionalButtonClick = () => {
    if (additionalButtonUrl) {
      // Invoke additionalButtonUrl if it's a function
      if (typeof additionalButtonUrl === "function") {
        additionalButtonUrl();
      } else {
        // Open a new window with the specified URL
        window.open(additionalButtonUrl, "_blank");
      }
    }
    // if (additionalButtonUrl) {

    //   window.open(additionalButtonUrl, "_blank");
    // }
  };

  return (
    <AppBar
      position="fixed"
      sx={{
        width: `calc(100% - ${drawerWidth}px)`,
        ml: `${drawerWidth}px`,
        background: bgColor ? bgColor : "#F5F5F5",
        boxShadow: "none",
      }}
      id="test-header"
    >
      <Toolbar>
        <Grid container alignItems={"center"}>
          <Grid
            item
            xs={actions ? true : 8}
            container
            alignItems={"center"}
          >
            {mainTitle === "Organization Profile Management" || hideBackArrow ? (
              ""
            ) : (
              <ArrowBackIcon
                fontSize="medium"
                onClick={onBackClick ? onBackClick : () => navigate(-1)}
                style={backIconStyles}
              />
            )}

            <Typography style={mainTitleStyles}>
              {mainTitle && mainTitle}
            </Typography>
          </Grid>
          {actions ? (
            <Grid item xs="auto" sx={actionsContainerStyles}>
              {actions}
            </Grid>
          ) : (
          <Grid item xs={4} container>
            {cancelButton && (
              <Button
                variant="outlined"
                style={cancelButtonStyles}
                onClick={
                  onCancelClick ? onCancelClick : () => setEditEnabled(false)
                }
              >
                Cancel
              </Button>
            )}

            {editEnabled ? (
              <LoadingButton
                variant="contained"
                style={saveButtonStyles}
                loading={loading}
                onClick={handleSave}
                disabled={disableEdit}
              >
                {submitButtonText ? submitButtonText : "Save"}
              </LoadingButton>
            ) : (
              <>
                {additionalButton && additionalButtonUrl && (
                  <Button
                    variant="contained"
                    style={accessButtonStyles}
                    onClick={handleAdditionalButtonClick}
                    disabled={disableEdit}
                  >
                    {additionalButton}
                  </Button>
                )}
                {showSendLink && (
                  <Button
                    variant="outlined"
                    style={{
                      ...sendLinkButtonStyles,
                      ...(disableSendLink
                        ? { color: "#B3B3B3", borderColor: "#B3B3B3" }
                        : {}),
                    }}
                    onClick={onSendLink}
                    disabled={disableSendLink}
                  >
                    Send Request Email
                  </Button>
                )}
                {showGetLink && (
                  <Button
                    variant="outlined"
                    style={{
                      ...sendLinkButtonStyles,
                      ...(disableGetLink
                        ? { color: "#B3B3B3", borderColor: "#B3B3B3" }
                        : {}),
                    }}
                    onClick={onGetLink}
                    disabled={disableGetLink}
                  >
                    Get Link
                  </Button>
                )}
                {buttonText ? (
                  <Button
                    variant="contained"
                    style={editButtonStyles}
                    onClick={() => setEditEnabled(true)}
                    disabled={disableEdit}
                  >
                    {buttonText}
                  </Button>
                ) : (
                  ""
                )}
              </>
            )}
          </Grid>
          )}
        </Grid>
      </Toolbar>
    </AppBar>
  );
};

export default DetailsPageHeader;

const backIconStyles = { color: "#00A7CD", marginRight: 15, cursor: "pointer" };
const mainTitleStyles = {
  color: "#020303",
  fontSize: 23,
  fontWeight: 700,
  fontFamily: "Avenir Book, sans-serif",
};
const editButtonStyles = {
  marginLeft: "auto",
  // marginLeft: 5,
  marginRight: 30,
  textTransform: "none",
  background: "#00A7CD",
  fontSize: 15,
  fontWeight: 500,
  fontFamily: "Avenir Book, sans-serif",
};

const accessButtonStyles = {
  marginLeft: "auto",
  // marginRight: 30,
  textTransform: "none",
  background: "#00A7CD",
  fontSize: 15,
  fontWeight: 500,
  fontFamily: "Avenir Book, sans-serif",
};
const saveButtonStyles = {
  marginRight: 30,
  textTransform: "none",
  background: "#00A7CD",
  fontSize: 15,
  fontWeight: 500,
  fontFamily: "Avenir Book, sans-serif",
};
const cancelButtonStyles = {
  marginLeft: "auto",
  marginRight: 10,
  textTransform: "none",
  color: "#00A7CD",
  fontSize: 15,
  fontWeight: 500,
  fontFamily: "Avenir Book, sans-serif",
};

const actionsContainerStyles = {
  display: "flex",
  alignItems: "center",
  gap: 2,
  marginRight: "30px",
};

// Shared header button designs (match e.g. Batched QuickTales header).
// Primary: blue background / white text.
export const headerPrimaryButtonSx = {
  backgroundColor: "#00a7cd",
  color: "#fff",
  textTransform: "none",
  fontSize: 15,
  fontWeight: 600,
  fontFamily: "Avenir Book, sans-serif",
  padding: "8px 20px",
  "&:hover": { backgroundColor: "#00acc1" },
};
// Secondary: white background / blue text + blue outline.
export const headerSecondaryButtonSx = {
  color: "#00a7cd",
  borderColor: "#00a7cd",
  backgroundColor: "#fff",
  textTransform: "none",
  fontSize: 15,
  fontWeight: 600,
  fontFamily: "Avenir Book, sans-serif",
  padding: "8px 20px",
  "&:hover": {
    borderColor: "#00acc1",
    backgroundColor: "rgba(0, 188, 212, 0.04)",
  },
};

const sendLinkButtonStyles = {
  marginRight: 10,
  textTransform: "none",
  color: "#00A7CD",
  borderColor: "#00A7CD",
  fontSize: 15,
  fontWeight: 500,
  fontFamily: "Avenir Book, sans-serif",
};
